<template>
  <div v-if="resolvedDealId" class="stock-deal-reference mt-1">
    <router-link
      :to="{ name: 'deals-view', params: { id: resolvedDealId } }"
      class="text-caption"
    >
      <v-icon x-small class="mr-1">mdi-briefcase-outline</v-icon>
      {{ label }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "StockDealReference",
  props: {
    dealId: {
      type: [Number, String],
      default: null,
    },
    deal: {
      type: Object,
      default: null,
    },
  },
  computed: {
    resolvedDealId() {
      if (this.dealId) {
        return Number(this.dealId);
      }
      if (this.deal && this.deal.id) {
        return Number(this.deal.id);
      }
      return null;
    },
    label() {
      const deal = this.deal;
      if (deal) {
        if (deal.label) {
          return deal.label;
        }
        if (deal.code && deal.name) {
          return `${deal.code} — ${deal.name}`;
        }
        if (deal.code || deal.name) {
          return deal.code || deal.name;
        }
      }
      return this.$t("STOCK.COMMON.OPEN_DEAL");
    },
  },
};
</script>
